<template>
  <b-modal :id="id" @ok="confirm" title="Повторить задачу" ok-title="Выполнить сейчас" header-bg-variant="success" header-text-variant="light" ok-variant="success">
    <p>Эта задача будет выполнена прямо сейчас. Вы уверены?</p>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'repeatTaskModal',
  mixins: [RekonoApi],
  props: {
    id: String,
    task: Object
  },
  methods: {
    confirm (event) {
      event.preventDefault()
      this.post(`/api/tasks/${this.task.id}/repeat/`, { }, this.task.process ? this.task.process.name : this.task.tool.name, 'Задача выполнена повторно успешно')
        .then(data => {
          this.$bvModal.hide(this.id)
          this.$router.push({ name: 'task', params: { id: data.id, task: data } })
        })
    }
  }
}
</script>
